/**
 * useGeriSayim — "Yeniden gönder" gibi bekleme düğmeleri için saniye cinsinden geri sayım (backlog #640).
 *
 * `const [kalan, baslat] = useGeriSayim(ilkSaniye)`: `kalan` her saniye azalır ve 0'da durur; `baslat(saniye)` sayımı yeniden başlatır.
 * Bitiş zamanı saklanır (kalan saniye değil), bu yüzden sekme arka planda kısılsa bile sayım gerçek saate göre doğru kalır.
 */
import { useCallback, useEffect, useState } from 'react';

export default function useGeriSayim(ilkSaniye = 0) {
  const [bitis, setBitis] = useState(() => (ilkSaniye > 0 ? Date.now() + ilkSaniye * 1000 : 0));
  const [simdi, setSimdi] = useState(() => Date.now());
  const surerken = bitis > simdi;

  useEffect(() => {
    if (!surerken) return undefined;
    const id = setInterval(() => setSimdi(Date.now()), 1000);
    return () => clearInterval(id);
  }, [surerken, bitis]);

  const baslat = useCallback((saniye) => {
    const su = Date.now();
    setSimdi(su);
    setBitis(saniye > 0 ? su + saniye * 1000 : 0);
  }, []);

  return [surerken ? Math.max(1, Math.ceil((bitis - simdi) / 1000)) : 0, baslat];
}
